import script from "./detailsShop.vue?vue&type=script&setup=true&lang=js"
export * from "./detailsShop.vue?vue&type=script&setup=true&lang=js"

import "./detailsShop.vue?vue&type=style&index=0&id=c350cef2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c350cef2"]])

export default __exports__